import { type FC } from "react";

import { ReactionAlpha } from "@moment/ui";

import { type DataGridUser } from "../Props";
import { type TableCellValueCommonProps } from "./types";

export interface TableCellValueReactionsProps extends TableCellValueCommonProps {
	currentUser?: DataGridUser;
}

export const TableCellValueReactions: FC<TableCellValueReactionsProps> = ({
	value,
	currentUser,
	defaultValue,
	onChange,
	isEditable,
}) => {
	return (
		<ReactionAlpha
			reactionsValue={value ?? defaultValue}
			onChangeReactions={onChange}
			currentUser={currentUser}
			disabled={!isEditable}
		/>
	);
};
